module.exports = __webpack_public_path__ + "img/fotn.812292bf.jpg";